import { MatLegacyPaginatorIntl as MatPaginatorIntl } from '@angular/material/legacy-paginator';
import { LocaleService } from './services/locale.service';

export class CustomPaginatorIntl extends MatPaginatorIntl {
  constructor(private localeService: LocaleService) {
    super();

    this.localeService
      .getString([
        'pagination.itemsPerPage',
        'pagination.nextPage',
        'pagination.previousPage',
        'pagination.firstPage',
        'pagination.lastPage',
        'pagination.of',
      ])
      .subscribe((translation) => {
        this.itemsPerPageLabel = translation['pagination.itemsPerPage'];
        this.nextPageLabel = translation['pagination.nextPage'];
        this.previousPageLabel = translation['pagination.previousPage'];
        this.firstPageLabel = translation['pagination.firstPage'];
        this.lastPageLabel = translation['pagination.lastPage'];
        this.changes.next();
      });
  }
}
